// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8bce1578","453":"cc456cf4","732":"edb0e6ef"}[chunkId] + ".chunk.js";
};